// Environment for uat

export const environment = {
  apiUrl: 'https://uat-api.startprint.net',
  uploadFuncUrl: 'https://upload-uat.startprint.net',
  firebaseConfig: {
    apiKey: 'AIzaSyDkNyenJtV5TaRm8RqPKn-7bfHu1sISYeI',
    authDomain: 'startprintproject.firebaseapp.com',
    projectId: 'startprintproject',
    storageBucket: 'startprintproject.firebasestorage.app',
    messagingSenderId: '862137346823',
    appId: '1:862137346823:web:0409c0a18cf67be402b3a2',
    vapidKey: 'BCiU_FultWIjm4_J2pXyonlOQy2GZi_SuoSF4D_ShBxGCOCp3AV3VmVcHtMFoFc44N2NKd6iCE1HGN2Ey1ctvm4',
  },
  appInsightsKey: '335b14b7-b295-458e-92f6-89305332a320',
  environmentName: 'uat',
};
